<template>
  <div>
    <div class="newQuestionsBackground md:py-12 dark:bg-purple-600">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle dark:text-white">
          Which of the following has a regular impact on your well-being?
          (select all that apply)
        </h2>
        <!-- Q3-1-->
        <div data-aos="fade-left" class="checkboxes">
          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[0] === idArr[0]
            "
          >
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              I do not have enough money
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              I do not have enough money
            </label>
          </span>

          <!-- Q3-2-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[1] === idArr[1]
            "
          >
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              I do not have enough to eat</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              I do not have enough to eat</label
            >
          </span>

          <!-- Q3-3-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[2] === idArr[2]
            "
          >
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              I am struggling to keep up my grades
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              I am struggling to keep up my grades
            </label>
          </span>

          <!-- Q3-4-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[3] === idArr[3]
            "
          >
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              I feel lonely/isolated
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              I feel lonely/isolated
            </label>
          </span>

          <!-- Q3-5-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[4] === idArr[4]
            "
          >
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              I am worried about what to do once I graduate
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              I am worried about what to do once I graduate
            </label>
          </span>

          <!-- Q3-6-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[5] === idArr[5]
            "
          >
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              I have recently experienced the death of a loved one
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              I have recently experienced the death of a loved one
            </label>
          </span>

          <!-- Q3-7-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[6] === idArr[6]
            "
          >
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              I am concerned about my substance use (prescription or recreational drugs/alcohol)
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              I am concerned about my substance use (prescription or recreational drugs/alcohol)
            </label>
          </span>

          <!-- Q3-8-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[7] === idArr[7]
            "
          >
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option8" class="dark:text-white dark:bg-hero-purple">
              I would like support navigating my faith and spirituality
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option8" class="dark:text-white dark:bg-hero-purple">
              I would like support navigating my faith and spirituality
            </label>
          </span>

          <!-- Q3-9-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[8] === idArr[8]
            "
          >
            <input
              type="checkbox"
              id="option9"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option9" class="dark:text-white dark:bg-hero-purple">
              I have sexual health concerns
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option9"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option9" class="dark:text-white dark:bg-hero-purple">
              I have sexual health concerns
            </label>
          </span>

          <!-- Q3-10-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[9] === idArr[9]
            "
          >
            <input
              type="checkbox"
              id="option10"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option10" class="dark:text-white dark:bg-hero-purple">
              I have been impacted by sexual violence
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option10"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option10" class="dark:text-white dark:bg-hero-purple">
              I have been impacted by sexual violence
            </label>
          </span>

          <!-- Q3-11-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[10] === idArr[10]
            "
          >
            <input
              type="checkbox"
              id="option11"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option11" class="dark:text-white dark:bg-hero-purple">
              I have concerns about eating or body image
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option11"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option11" class="dark:text-white dark:bg-hero-purple">
              I have concerns about eating or body image
            </label>
          </span>

          <!-- Q3-12-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[11] === idArr[11]
            "
          >
            <input
              type="checkbox"
              id="option12"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option12" class="dark:text-white dark:bg-hero-purple">
              I would like support with gender identity
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option12"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option12" class="dark:text-white dark:bg-hero-purple">
              I would like support with gender identity
            </label>
          </span>

          <!-- Q3-13-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[12] === idArr[12]
            "
          >
            <input
              type="checkbox"
              id="option13"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option13" class="dark:text-white dark:bg-hero-purple">
              I am struggling to adjust to student life
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option13"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option13" class="dark:text-white dark:bg-hero-purple">
              I am struggling to adjust to student life
            </label>
          </span>

          <!-- Q3-14-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[13] === idArr[13]
            "
          >
            <input
              type="checkbox"
              id="option14"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option14" class="dark:text-white dark:bg-hero-purple">
              I am concerned about my overall mental health and well-being
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option14"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option14" class="dark:text-white dark:bg-hero-purple">
              I am concerned about my overall mental health and well-being
            </label>
          </span>

          <!-- Q3-15-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[14] === idArr[14]
            "
          >
            <input
              type="checkbox"
              id="option15"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option15" class="dark:text-white dark:bg-hero-purple">
              I would like support with my sexuality
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option15"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option15" class="dark:text-white dark:bg-hero-purple">
              I would like support with my sexuality
            </label>
          </span>

          <!-- Q3-16-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[15] === idArr[15]
            "
          >
            <input
              type="checkbox"
              id="option16"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option16" class="dark:text-white dark:bg-hero-purple">
              I have experienced discrimination or harassment based on my
              identity
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option16"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option16" class="dark:text-white dark:bg-hero-purple">
              I have experienced discrimination or harassment based on my
              identity
            </label>
          </span>

          <!-- Q3-17-->

          <span
            v-if="
              $store.state.views.questionThree.checkedButtons[16] === idArr[16]
            "
          >
            <input
              type="checkbox"
              id="option17"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option17" class="dark:text-white dark:bg-hero-purple">
              People treat me differently because of my identity
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option17"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option17" class="dark:text-white dark:bg-hero-purple">
              People treat me differently because of my identity
            </label>
          </span>

          <!-- Q3-18-->

          <span
              v-if="
              $store.state.views.questionThree.checkedButtons[17] === idArr[17]
            "
          >
            <input
                type="checkbox"
                id="option18"
                v-on:click="checkboxesChecked"
                name="impact[]"
                checked
            />

            <label for="option18" class="dark:text-white dark:bg-hero-purple">
              I am concerned with gambling addiction
            </label>
          </span>

          <span v-else>
            <input
                type="checkbox"
                id="option18"
                v-on:click="checkboxesChecked"
                name="impact[]"
            />

            <label for="option18" class="dark:text-white dark:bg-hero-purple">
              I am concerned with gambling addiction
            </label>
          </span>
          <!-- Q3-19-->

          <span
              v-if="
              $store.state.views.questionThree.checkedButtons[18] === idArr[18]
            "
          >
            <input
                type="checkbox"
                id="option19"
                v-on:click="checkboxesChecked"
                name="impact[]"
                checked
            />

            <label for="option19" class="dark:text-white dark:bg-hero-purple">
              I am facing homelessness or at risk of losing my home
            </label>
          </span>

          <span v-else>
            <input
                type="checkbox"
                id="option19"
                v-on:click="checkboxesChecked"
                name="impact[]"
            />

            <label for="option19" class="dark:text-white dark:bg-hero-purple">
             I am facing homelessness or at risk of losing my home
            </label>
          </span>
          <!-- Q3-20-->

          <span
              v-if="
              $store.state.views.questionThree.checkedButtons[19] === idArr[19]
            "
          >
            <input
                type="checkbox"
                id="option20"
                v-on:click="checkboxesChecked"
                name="impact[]"
                checked
            />

            <label for="option20" class="dark:text-white dark:bg-hero-purple">
              I am experiencing legal issues
            </label>
          </span>

          <span v-else>
            <input
                type="checkbox"
                id="option20"
                v-on:click="checkboxesChecked"
                name="impact[]"
            />

            <label for="option20" class="dark:text-white dark:bg-hero-purple">
             I am experiencing legal issues
            </label>
          </span>
          <!-- Q3-21-->

          <span
              v-if="
              $store.state.views.questionThree.checkedButtons[20] === idArr[20]
            "
          >
            <input
                type="checkbox"
                id="option21"
                v-on:click="checkboxesChecked"
                name="impact[]"
                checked
            />

            <label for="option21" class="dark:text-white dark:bg-hero-purple">
              I am experiencing domestic violence by a current or former spouse or partner in an intimate relationship
            </label>
          </span>

          <span v-else>
            <input
                type="checkbox"
                id="option21"
                v-on:click="checkboxesChecked"
                name="impact[]"
            />

            <label for="option21" class="dark:text-white dark:bg-hero-purple">
             I am experiencing domestic violence by a current or former spouse or partner in an intimate relationship
            </label>
          </span>
        </div>
        <small class="py-10 my-8 mb-0 block font-medium dark:text-white">
          <svg
            class="w-4 h-4 float-left mr-2"
            width="108"
            height="108"
            viewBox="0 0 108 108"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M54 0C24.1787 0 0 24.1874 0 54C0 83.83 24.1787 108 54 108C83.8213 108 108 83.83 108 54C108 24.1874 83.8213 0 54 0ZM54 23.9516C59.0507 23.9516 63.1452 28.046 63.1452 33.0968C63.1452 38.1475 59.0507 42.2419 54 42.2419C48.9493 42.2419 44.8548 38.1475 44.8548 33.0968C44.8548 28.046 48.9493 23.9516 54 23.9516ZM66.1935 79.2581C66.1935 80.701 65.0236 81.871 63.5806 81.871H44.4194C42.9764 81.871 41.8065 80.701 41.8065 79.2581V74.0323C41.8065 72.5893 42.9764 71.4194 44.4194 71.4194H47.0323V57.4839H44.4194C42.9764 57.4839 41.8065 56.3139 41.8065 54.871V49.6452C41.8065 48.2022 42.9764 47.0323 44.4194 47.0323H58.3548C59.7978 47.0323 60.9677 48.2022 60.9677 49.6452V71.4194H63.5806C65.0236 71.4194 66.1935 72.5893 66.1935 74.0323V79.2581Z"
              fill="#979797"
            />
          </svg>
          Note: This is not a comprehensive list of areas that can impact your
          well-being. The above list is designed to help curate a specific list
          of services and resources for you. If you need to talk to someone,
          <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-0.5"
            href="https://wellness.carleton.ca/get-help-now/"
            target="_blank"
            >please reach out for assistance</a
          >
        </small>
      </div>
    </div>

    <div
      class="
        alignFooter
        dark:bg-hero-purple
        border-b border-gray-200
        dark:border-hero-purple
      "
    >
      <div class="footerContainer">
        <HelpDialog />

        <button
          v-on:click="nextQuestion"
          v-if="
            isActive ||
            $store.state.views.questionThree.nextButtonActive == true
          "
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";
export default {
  data() {
    return {
      answerOptions: {
        0: "Finances",
        1: "Food",
        2: "Academics",
        3: "Campus Life",
        4: "Employability",
        5: "Bereavement",
        6: "Substance",
        7: "Spirituality",
        8: "Sexual Health",
        9: "Sexual Violence",
        10: "Eating Disorders",
        11: "Gender",
        12: "Campus Life",
        13: "General",
        14: "Sexuality",
        15: "Discrimination",
        16: "Discrimination",
        17: "Gambling",
        18: "Housing",
        19: "Legal",
        20: "Domestic Violence",
      },

      idArr: {
        0: "option1",
        1: "option2",
        2: "option3",
        3: "option4",
        4: "option5",
        5: "option6",
        6: "option7",
        7: "option8",
        8: "option9",
        9: "option10",
        10: "option11",
        11: "option12",
        12: "option13",
        13: "option14",
        14: "option15",
        15: "option16",
        16: "option17",
        17: "option18",
        18: "option19",
        19: "option20",
        20: "option21",
      },
      isActive: false,
    };
  },

  components: { BackButton, HelpDialog },

  mounted: function () {
    this.scrollToTop();
    this.track();
  },

  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step3" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },
    checkboxesChecked() {
      var checkboxes = document.getElementsByName("impact[]");
      var total = 0;

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          total = total + 1;
        }
      }

      if (total === 0) {
        this.isActive = false;
        store.commit("setNextButtonDeactive", '["questionThree"]');
      } else {
        this.isActive = true;
      }
    },
    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];

      var checkboxes = document.getElementsByName("impact[]");
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          answerArray.push(this.answerOptions[i]);
        }
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          activeChecked[i] = checkboxes[i].id;
        } else {
          activeChecked[i] = "NULL";
        }
      }

      answerArray = this.removeDuplicates(answerArray);

      for (let i = 0; i < answerArray.length; i++) {
        const currentURL = new URL(location.href);
        const isDemo = currentURL.searchParams.get('demo') === 'true';

        if (!isDemo) {
            this.$gtag.event("q3-answer", {
            event_category: "answers",
            event_label: answerArray[i],
          });
        } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
        }
      }

      var objectForPages = {
        index: '["questionThree"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionThree"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionThree"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionFour"]');
    },

    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    removeDuplicates(arr) {
      return arr.filter((item, index) => arr.indexOf(item) === index);
    },
  },
};
</script>
